import type { OvpApiResult } from '@bldsoft/cappie/api/ovp'
import { createEffect } from 'effector'
import { client } from '../../client'
import { type HeaderFxParameter } from '../../index.h'
import { callInitFromParams } from '../../lib'
import { LaunchData } from './index.h'

function toLaunchData(result: OvpApiResult<unknown>): LaunchData {
  if (result.kind === 'success') {
    const body = result.body

    if (body && typeof body === 'object' && 'status' in body) {
      const envelope = body as LaunchData
      return {
        status: envelope.status,
        errorCode: envelope.errorCode,
      }
    }

    return { status: 'OK' }
  }

  if (result.kind === 'api-error') {
    return {
      status: 'ERROR',
      errorCode: result.errorCode,
    }
  }

  return {}
}

// GET /api/web/launch
export const checkFx = createEffect<HeaderFxParameter, LaunchData, Error>(
  async (params) => {
    const result = await client.get.api.web.launch(callInitFromParams(params))
    const data = toLaunchData(result)

    if (!data.status && !data.errorCode) {
      throw new Error('Empty answer in launch.checkFx')
    }

    return data
  }
)
